export enum TxType {
  ETH_SEND_TRANSACTION = "eth_sendTransaction",
  ETH_SIGN_MESSAGE = "eth_signMessage",
}
